import PptxGenJS from 'pptxgenjs';
import { LAYOUT, COLORS, FONTS } from '../helpers/constants';
import { addConfidentialDisclaimer, contactSection } from '../template-parts';
import { PPTImageManager } from '../helpers/image-manager';
import { BASE_URL } from '@/config';

interface BackCoverData {
    id: string;
}

const WIDTH = LAYOUT.width;
const HEIGHT = LAYOUT.height;
const MARGIN = LAYOUT.margin;

export function backCoverSlide(pptx: PptxGenJS, data: BackCoverData, imageManager: PPTImageManager) {

    const slide = pptx.addSlide();
    const { id } = data;
    const opportunityURL = `${BASE_URL}/opportunities/${id}`;
    const logoWhite = imageManager.get('logo-white');

    // Background green
    slide.addShape(pptx.ShapeType.rect, {
        x: 0,
        y: 0,
        w: WIDTH,
        h: HEIGHT,
        fill: { color: COLORS.primary },
        line: { type: 'none' },
    });

    if (logoWhite) {
        slide.addImage({
            data: logoWhite,
            x: 1.57,
            y: 2.32,
            w: 4.46,
            h: 1.27,
        });
    }

    slide.addText('Feel free to contact us if you need any help:', {
        x: 0.4,
        y: 8,
        w: 5,
        h: 0.3,
        fontFace: FONTS.body,
        fontSize: 12,
        bold: true,
        color: COLORS.white
    });

    // Website, email and link to opportunity
    contactSection(slide, imageManager, opportunityURL);

    // Confidential disclaimer
    addConfidentialDisclaimer(slide);
}
